import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModelCodeModalService {

  private selectedModelCodeSubject = new BehaviorSubject<any>(null);
  public selectedModelCode$ = this.selectedModelCodeSubject.asObservable();

  constructor() { }

  setSelectedModelCode(modelCode: any): void {
    this.selectedModelCodeSubject.next(modelCode);
  }

  getSelectedModelCode(): any | null {
    return this.selectedModelCodeSubject.value;
  }

  clearSelectedModelCode(): void {
    this.selectedModelCodeSubject.next(null);
  }
}
